import { Widget } from './Widget';

export class Response {
	/** Indicates if request was successful. */
	public isSuccess: boolean;
	public requestId: string;
	/** Array of requested widgets. */
	public widgetItems?: Widget[];

	public constructor(init: Response) {
		Object.assign(this, init);
		this.widgetItems = init.widgetItems?.map((r) => new Widget(r));
	}
}
